"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uniqBy_1 = __importDefault(require("lodash/uniqBy"));

var selectors_1 = require("@widget-editor/shared/lib/modules/theme/selectors");

var selectors_2 = require("@widget-editor/shared/lib/modules/end-user-filters/selectors");

var chart_common_1 = __importDefault(require("./chart-common"));

var Pie =
/*#__PURE__*/
function (_chart_common_1$defau) {
  _inherits(Pie, _chart_common_1$defau);

  function Pie() {
    _classCallCheck(this, Pie);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pie).apply(this, arguments));
  }

  _createClass(Pie, [{
    key: "generateSchema",
    value: function generateSchema() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.setScales();
                _context.t1 = this.setMarks();
                _context.t2 = this.bindData();
                _context.t3 = this.resolveScheme();
                _context.t4 = this.interactionConfig();
                _context.t5 = this.setLegend();
                _context.t6 = [];
                _context.t7 = _toConsumableArray;
                _context.next = 10;
                return this.resolveSignals();

              case 10:
                _context.t8 = _context.sent;
                _context.t9 = (0, _context.t7)(_context.t8);
                _context.t10 = [{
                  name: "width",
                  value: "",
                  on: [{
                    events: {
                      source: "window",
                      type: "resize"
                    },
                    update: "containerSize()[0]*0.95"
                  }]
                }];
                _context.t11 = _context.t6.concat.call(_context.t6, _context.t9, _context.t10);
                this.schema = {
                  scales: _context.t0,
                  marks: _context.t1,
                  data: _context.t2,
                  config: _context.t3,
                  interaction_config: _context.t4,
                  legend: _context.t5,
                  signals: _context.t11
                };

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setGenericSettings",
    value: function setGenericSettings() {
      this.schema = Object.assign(Object.assign({}, this.schema), {
        autosize: {
          type: "fit",
          contains: "padding"
        }
      });
    }
  }, {
    key: "interactionConfig",
    value: function interactionConfig() {
      return [{
        name: "tooltip",
        config: {
          fields: [{
            column: "value",
            property: this.resolveName('y'),
            type: "number",
            format: '.2s'
          }, {
            column: "pie_category",
            property: this.resolveName('x'),
            type: 'string'
          }]
        }
      }];
    }
  }, {
    key: "setScales",
    value: function setScales() {
      var scheme = selectors_1.selectScheme(this.store);
      return [{
        name: "c",
        type: "ordinal",
        domain: {
          data: "color",
          field: "pie_category"
        },
        range: scheme.category
      }];
    }
  }, {
    key: "resolveInnerRadius",
    value: function resolveInnerRadius() {
      var configuration = this.store.configuration;

      if (configuration.chartType === "pie") {
        return "0";
      }

      return configuration.donutRadius;
    }
  }, {
    key: "setMarks",
    value: function setMarks() {
      return [{
        type: "arc",
        from: {
          data: "final"
        },
        encode: {
          enter: {
            fill: {
              scale: "c",
              field: "pie_category"
            },
            x: {
              signal: "width / 2"
            },
            y: {
              signal: "height / 2"
            }
          },
          update: {
            startAngle: {
              field: "startAngle"
            },
            endAngle: {
              field: "endAngle"
            },
            innerRadius: {
              signal: this.resolveInnerRadius()
            },
            outerRadius: {
              signal: "width > height ? height / 2 : width / 2"
            },
            opacity: {
              value: 1
            }
          },
          hover: {
            opacity: {
              value: 0.8
            }
          }
        }
      }];
    }
  }, {
    key: "bindData",
    value: function bindData() {
      var _this$store = this.store,
          widgetData = _this$store.editor.widgetData,
          configuration = _this$store.configuration;
      var endUserFilters = selectors_2.selectEndUserFilters(this.store);
      return [{
        name: "table",
        values: widgetData
      }, {
        name: "color",
        source: "table",
        transform: [{
          "type": "window",
          "ops": ["row_number"],
          "as": ["rank"]
        }, {
          "type": "formula",
          "as": "pie_category",
          "expr": endUserFilters.length ? 'datum.x' : "datum.rank < ".concat(configuration.sliceCount, " ? datum.x : 'Others'")
        }, {
          "type": "aggregate",
          "groupby": ["pie_category"],
          "ops": ["sum"],
          "fields": ["y"],
          "as": ["value"]
        }]
      }, {
        name: "filtered",
        source: "table",
        transform: this.resolveEndUserFiltersTransforms()
      }, {
        name: "final",
        source: "filtered",
        transform: [{
          "type": "window",
          "ops": ["row_number"],
          "as": ["rank"]
        }, {
          "type": "formula",
          "as": "pie_category",
          "expr": endUserFilters.length ? 'datum.x' : "datum.rank < ".concat(configuration.sliceCount, " ? datum.x : 'Others'")
        }, {
          "type": "aggregate",
          "groupby": ["pie_category"],
          "ops": ["sum"],
          "fields": ["y"],
          "as": ["value"]
        }, {
          "type": "pie",
          "field": "value",
          "startAngle": 0,
          "endAngle": 6.29
        }]
      }];
    }
  }, {
    key: "setLegend",
    value: function setLegend() {
      var scheme = this.resolveScheme();
      var _this$store2 = this.store,
          widgetData = _this$store2.editor.widgetData,
          configuration = _this$store2.configuration;
      var endUserFilters = selectors_2.selectEndUserFilters(this.store);

      if (!widgetData) {
        return null;
      }

      var values;

      if (endUserFilters.length) {
        values = widgetData.map(function (d, i) {
          return {
            label: d.x,
            value: scheme.range.category20[i % scheme.range.category20.length],
            type: 'string'
          };
        });
      } else {
        values = uniqBy_1["default"](widgetData.map(function (d, i) {
          return Object.assign(Object.assign({}, d), {
            x: i + 1 < configuration.sliceCount ? d.x : 'Others'
          });
        }), 'x').slice(0, configuration.sliceCount).map(function (d, i) {
          return {
            label: d.x,
            value: scheme.range.category20[i % configuration.sliceCount],
            type: 'string'
          };
        });
      }

      return [{
        type: 'color',
        label: null,
        shape: 'square',
        values: values
      }];
    }
  }, {
    key: "getChart",
    value: function getChart() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.generateSchema();

              case 2:
                this.setGenericSettings();
                return _context2.abrupt("return", this.schema);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return Pie;
}(chart_common_1["default"]);

exports["default"] = Pie;